import { useEffect } from "react";
import GeneralSummary from "../../components/dashboard/GeneralSummary";
import CampaignSummary from "../../components/dashboard/CampaignSummary";
import PageLayout from "../../components/shared/PageLayout";
import SubscriptionSource from "../../components/dashboard/SubscriptionSource";
import { StyledDashboard } from "./index.styled";
import { extractAndSaveToken, extractAndSaveStatusId } from "../../utils/apiService";
import { useDashboard } from "../../hooks/useDashboard";
import {
  DashboardFilterProvider,
  useDashboardFilter,
} from "../../contexts/DashboardFilterContext";
import { useAppSelector } from "../../hooks/redux";

const DashboardContent = () => {
  const { selectedMonth } = useDashboardFilter();
  const statusIdFromUrl = useAppSelector((state) => state.dashboard.statusIdFromUrl);
  const {
    refetchData,
    refetchViewsTriggersData,
    refetchYearlyViewsTriggersData,
    refetchWeeklyViewsTriggersData,
    refetchDailyViewsTriggersData,
    refetchViewsSourcesData,
  } = useDashboard();

  useEffect(() => {
    extractAndSaveToken();
    extractAndSaveStatusId();

    refetchData();
    refetchViewsTriggersData();
    refetchYearlyViewsTriggersData();
    refetchWeeklyViewsTriggersData();
    refetchDailyViewsTriggersData();
  }, [
    statusIdFromUrl,
    refetchData,
    refetchViewsTriggersData,
    refetchYearlyViewsTriggersData,
    refetchWeeklyViewsTriggersData,
    refetchDailyViewsTriggersData,
  ]);

  // Check if specific month is selected and fetch views sources data
  useEffect(() => {
    if (selectedMonth !== undefined) {
      refetchViewsSourcesData();
    }
  }, [selectedMonth, refetchViewsSourcesData]);

  return (
    <PageLayout
      title="נתונים וסטטיסטיקות"
      StyledComponent={StyledDashboard}
      containerClassName="dashboard-container"
    >
      <GeneralSummary />
      <CampaignSummary />
      <SubscriptionSource />
    </PageLayout>
  );
};

const Dashboard = () => {
  return (
    <DashboardFilterProvider>
      <DashboardContent />
    </DashboardFilterProvider>
  );
};

export default Dashboard;
